<template>
  <NavbarTwo />
  <MainBanner />
  <WhoWeAre />
  <OurFeatures />
  <OurContent />
  <EnjoyYourTime class="bg-gondola3" className="text-white" />
  <FavoriteMatch />
  <PricingPlans />
  <TestOurService />
  <OnlyBenefits />
  <OurTestimonial />
  <FanFact />
  <FAQ />
  <MainFooter
    class="bg-secondary bg-img"
    :style="{ backgroundImage: `url(${bgImage})` }"
  />
  <CopyRight />
</template>

<script lang="ts">
import { defineComponent, onBeforeUnmount, onMounted } from "vue";
import { useHead } from "@unhead/vue";
import NavbarTwo from "@/components/Layouts/NavbarTwo.vue";
import MainBanner from "@/components/IPTVService/MainBanner/index.vue";
import WhoWeAre from "@/components/IPTVService/WhoWeAre.vue";
import OurFeatures from "@/components/IPTVService/OurFeatures.vue";
import OurContent from "@/components/IPTVService/OurContent.vue";
import EnjoyYourTime from "@/components/Common/EnjoyYourTime.vue";
import FavoriteMatch from "@/components/IPTVService/FavoriteMatch.vue";
import PricingPlans from "@/components/IPTVService/PricingPlans.vue";
import TestOurService from "@/components/IPTVService/TestOurService.vue";
import OnlyBenefits from "@/components/IPTVService/OnlyBenefits.vue";
import OurTestimonial from "@/components/IPTVService/OurTestimonial.vue";
import FanFact from "@/components/IPTVService/FanFact.vue";
import FAQ from "@/components/IPTVService/FAQ.vue";
import MainFooter from "@/components/Layouts/MainFooter.vue";
import CopyRight from "@/components/Layouts/CopyRight.vue";

export default defineComponent({
  name: "IPTVServicePage",
  components: {
    NavbarTwo,
    MainBanner,
    WhoWeAre,
    OurFeatures,
    OurContent,
    EnjoyYourTime,
    FavoriteMatch,
    PricingPlans,
    TestOurService,
    OnlyBenefits,
    OurTestimonial,
    FanFact,
    FAQ,
    MainFooter,
    CopyRight,
  },
  setup() {
    useHead({
      title: "اشتراك IPTV للقنوات العربية | بث مباشر بجودة HD و 4K",
      meta: [
        {
          name: "description",
          content:
            "احصل على أفضل اشتراك IPTV لمشاهدة القنوات العربية بجودة HD و4K مع بث مباشر مستقر، آلاف القنوات، مكتبة أفلام ومسلسلات، وسيرفرات سريعة تعمل على جميع الأجهزة.",
        },
        {
          name: "keywords",
          content:
            "اشتراك IPTV, IPTV عربي, قنوات عربية, بث مباشر, IPTV HD, IPTV 4K, قنوات رياضية, قنوات أطفال, أفلام, مسلسلات",
        },
        {
          property: "og:title",
          content: "اشتراك IPTV للقنوات العربية",
        },
        {
          property: "og:description",
          content:
            "استمتع بأفضل خدمة IPTV لمشاهدة القنوات العربية والعالمية بجودة عالية وثبات ممتاز على جميع الأجهزة.",
        },
        {
          property: "og:type",
          content: "website",
        },
        {
          name: "robots",
          content: "index, follow",
        },
      ],
    });

    // eslint-disable-next-line @typescript-eslint/no-var-requires
    const bgImage = require("@/assets/images/footer-shape.png");

    onMounted(() => {
      document.body.classList.add("bg-gondola");
    });

    onBeforeUnmount(() => {
      document.body.classList.remove("bg-gondola");
    });

    return { bgImage };
  },
});
</script>